import React from "react";
import api from "../../../services/api/axios";
import ProspectingTagEditor from "../shared/ProspectingTagEditor";

const AUTO_TAGS = new Set([
  "Potential Prospect",
  "Customer / Existing Employer",
  "High Intent",
  "Low Intent",
  "Target Industry",
]);

const TAG_ALIASES = {
  "🎯 Target Industry": "Target Industry",
  "Lead – High Intent": "High Intent",
  "Lead – Low Intent": "Low Intent",
};

function normalizeTags(tags = []) {
  if (!Array.isArray(tags)) return [];

  const seen = new Set();
  const normalized = [];

  tags.forEach((value) => {
    const rawTag = String(value || "").trim();
    const tag = TAG_ALIASES[rawTag] || rawTag;
    if (!tag || seen.has(tag)) return;
    seen.add(tag);
    normalized.push(tag);
  });

  return normalized;
}

function splitTags(tags = []) {
  const normalized = normalizeTags(tags);
  return {
    autoTags: normalized.filter((tag) => AUTO_TAGS.has(tag)),
    userTags: normalized.filter((tag) => !AUTO_TAGS.has(tag)),
  };
}

function ProspectingCompanyTags({
  companyId,
  tags,
  onTagsUpdated,
}) {
  const { autoTags, userTags } = splitTags(tags);

  return (
    <ProspectingTagEditor
      entityId={companyId}
      userTags={userTags}
      autoTags={autoTags}
      layout="column"
      onCommit={async (nextTags) => {
        const combinedTags = normalizeTags([...autoTags, ...nextTags]);
        const { data } = await api.patch(`/prospecting-companies/${companyId}`, {
          tags: combinedTags,
        });
        const resolvedTags = normalizeTags(
          Array.isArray(data?.tags) ? data.tags : combinedTags,
        );
        const { userTags: resolvedUserTags } = splitTags(resolvedTags);
        onTagsUpdated?.(companyId, resolvedTags);
        return resolvedUserTags;
      }}
      onTagsUpdated={(nextTags) => {
        onTagsUpdated?.(companyId, normalizeTags([...autoTags, ...nextTags]));
      }}
    />
  );
}

export default React.memo(ProspectingCompanyTags);
